import axios from "axios";
import queryString from "query-string";
import { message } from "antd";
// import {logout} from "@/Auth/index";
import * as config from "@/config/const";
import { ResponseCode, ResponseType, AnyType } from "@/types";

axios.defaults.baseURL = config.BASEURL;
axios.defaults.timeout = config.TIMEOUT;
// axios.defaults.headers.post["Content-Type"] = config.CONTENTTYPE;

interface reqProps {
  url: string;
  params?: { [key: string]: any };
  method?: string;
  isQuery?: boolean;
  headers?: { [key: string]: any };
  withDefaultHeader?: boolean;
}

export const request: (a: reqProps) => Promise<any> = (p: reqProps) => {
  const token: string = window.localStorage.getItem(config.LOGINTOKEN) || "";
  let {
    params = {},
    url = "",
    method = "get",
    isQuery = false,
    headers = {},
    withDefaultHeader = true,
  } = p;

  const defaultHeader = token
    ? { Authorization: `Bearer ${token}`, "Content-Type": config.CONTENTTYPE }
    : { "Content-Type": config.CONTENTTYPE };

  if (withDefaultHeader) {
    headers = { ...headers, ...defaultHeader };
  }
  url = isQuery ? `${url}?${queryString.stringify(params!)}` : url;
  method = method.toLowerCase();
  const sparam: AnyType | string | null = isQuery
    ? null
    : method === "post"
    ? JSON.stringify(params)
    : params;
  console.log("========request=============", axios.defaults.baseURL,url, method, params);

  const rp: { [key: string]: any } = {
    url,
    method,
    data: sparam,
  };
  if (Object.keys(headers)) {
    rp.headers = headers;
  }
  console.log(`[request] request with data: ${JSON.stringify(rp)}`);
  return axios(rp)
    .then((response) => {
       
      const { msg, code, data } = response.data as ResponseType;
      if (code === ResponseCode.success) {
        console.log("======request success, ", axios.defaults.baseURL,url, response.data);
        return data;
      } else if (code === ResponseCode.unauthorized) {
        //token过期 logout
        window.localStorage.removeItem(config.LOGINTOKEN);
        window.location.href = "/";
        // logout()
        return Promise.reject(data);
      } else {
        console.log(url + "" === "" + msg);
        //message.error(msg);
        //return Promise.reject(data || response.data);
        //we should check code such as 
        return Promise.reject({code, message:msg})
      }
    })
    .catch((error) => {
      console.log(axios.defaults.baseURL+ url + "===" + (error.errorMsg || error.msg));
      return Promise.reject(error);
    });
};
